'use strict';

module.exports = function (length) {
	if (!length) {
		return function () { return ''; };
	}
	return function (args) {
		var id = String(args[0]), i = 0, l = length;
		while (--l) { id += '\u0001' + args[++i]; }
		return id;
	};
};



//////////////////
// WEBPACK FOOTER
// ./~/memoizee/normalizers/get-primitive-fixed.js
// module id = 953
// module chunks = 0